import VueI18n from "vue-i18n";
import Vue from "vue";
import zh from "@/locales/zh.json";
import en from "@/locales/en.json";

Vue.use(VueI18n);

// 从 localStorage 获取语言设置，默认使用 en_US
const getLocale = () => {
  try {
    return localStorage.getItem("lang") || "en_US";
  } catch (e) {
    return "en_US";
  }
};

const i18n = new VueI18n({
  locale: getLocale(), // 语言标识
  fallbackLocale: "en_US", // 默认语言
  messages: {
    zh_CN: zh, // 中文语言包
    en_US: en // 英文语言包
  }
});

export default i18n;
